import React from "react";
import LinearGoldText from "./linear-gold-text.tsx";
import "./game-payout-rate.css";
import GamePayoutItem from "./game-payout-item.tsx";

export default function GamePayoutRate({ isMobile }) {
  const getRandomNumbers = () => {
    let numbers: number[] = [];
    while (numbers.length < 3) {
      let randomNum: number = Math.floor(Math.random() * (41 - 1 + 1)) + 1;
      if (!numbers.includes(randomNum)) {
        numbers.push(randomNum);
      }
    }
    return numbers;
  };

  return (
    <div style={{ width: "100%" }}>
      <LinearGoldText isMobile={isMobile} style={{ marginBottom: "15px" }}>
        Game Payout Rate
      </LinearGoldText>
      <div
        style={{
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        {getRandomNumbers().map((item) => (
          <GamePayoutItem key={item} item={item} isMobile={isMobile} />
        ))}
      </div>
    </div>
  );
}
